import { render, staticRenderFns } from "./ContraindicationsWarningModal.vue?vue&type=template&id=252eeaf7&scoped=true"
import script from "./ContraindicationsWarningModal.vue?vue&type=script&lang=js"
export * from "./ContraindicationsWarningModal.vue?vue&type=script&lang=js"
import style0 from "./ContraindicationsWarningModal.vue?vue&type=style&index=0&id=252eeaf7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252eeaf7",
  null
  
)

export default component.exports